module.exports = __webpack_public_path__ + "named-1bdc66008e874ce27ab728e556465ec2-mstile-144x144.png";